import { gql } from '@apollo/client';

export const CREATE_EXCLUSION_TEMPLATE = gql`
    mutation CreateExcludedCountriesTemplate(
        $input: CreateExcludedCountriesTemplateInput!
    ) {
        createExcludedCountriesTemplate(input: $input) {
            identifier {
                id
            }
            templateName
            excludedCountries {
                countryISOCode
                exclusionType
            }
            createdAt
            updatedAt
        }
    }
`;

export const GET_EXCLUSION_TEMPLATES = gql`
    query GetExclusionTemplates {
        searchExcludedCountriesTemplates {
            excludedCountriesTemplates {
                identifier {
                    id
                }
                templateName
                excludedCountries {
                    countryISOCode
                    exclusionType
                }
                createdAt
                updatedAt
            }
            count
        }
    }
`;

export const GET_EXCLUSION_TEMPLATE = gql`
    query GetExcludedCountriesTemplate($id: UUID!) {
        excludedCountriesTemplate(id: $id) {
            identifier {
                id
            }
            templateName
            excludedCountries {
                countryISOCode
                exclusionType
            }
            createdAt
            updatedAt
        }
    }
`;

export const UPDATE_EXCLUSION_TEMPLATE = gql`
    mutation UpdateExcludedCountriesTemplate(
        $input: UpdateExcludedCountriesTemplateInput!
    ) {
        updateExcludedCountriesTemplate(input: $input) {
            identifier {
                id
            }
            templateName
            excludedCountries {
                countryISOCode
                exclusionType
            }
            updatedAt
        }
    }
`;

export const DELETE_EXCLUSION_TEMPLATE = gql`
    mutation DeleteExcludedCountriesTemplate($templateId: String!) {
        deleteExcludedCountriesTemplate(templateId: $templateId) {
            identifier {
                id
            }
        }
    }
`;
